module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_footer_chapel-576cec7c71ee7d5e1aca5b5791c462c7.svg";